import React from 'react';
import CheckInCard from './CheckInCard';

interface IProps {
  checkInList: any;
  checkInInfo: any;
  setCheckInInfo: any;
}

const ListOfEnquiry = (props: IProps) => {
  const { checkInList, checkInInfo, setCheckInInfo } = props;
  return (
    <div className="flex flex-col gap-2.5 xl:overflow-y-auto p-2 md:pr-2.5">
      {checkInList.map((info: any) => (
        <CheckInCard info={info} checkInInfo={checkInInfo} setCheckInInfo={setCheckInInfo} />
      ))}
    </div>
  );
};

export default ListOfEnquiry;
